import { CalculatedConsumablesDemandThemeModeConfig } from './types';

const dark: CalculatedConsumablesDemandThemeModeConfig = {
  calculatedConsumablesDemand: {},
};

export default dark;
